export default {
	form: {
		to: {
			name: '',
			email: '',
			message: '',
		},
		from: {
			name: '',
			email: '',
			phone: '',
			publish: true,
		},
		gift: null,
		donation: 0,
		payment: null,
	},
	entries: 0,

	// This is the indication if we show the bouncing arrow or not.
	bouncingArrow: true,
};



// WEBPACK FOOTER //
// ./src/store/state.js